import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rent-vs-buy',
  component: () => import('../../routes/RentVsBuy.svelte'),
  card: {
    id: 'rent-vs-buy',
    title: 'Rent vs Buy Calculator',
    description: 'Compare the total cost of renting versus buying a home over time, including equity, appreciation, and investment returns.',
    icon: 'compare_arrows',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/rent-vs-buy',
    category: 'Real Estate',
  },
  seo: {
    title: 'Rent vs Buy Calculator – Should You Rent or Buy a Home?',
    description: 'Free rent vs buy calculator. Compare the total cost of renting versus buying a home over time. Includes mortgage payments, property taxes, maintenance, home appreciation, investment returns, break-even analysis, and side-by-side cost comparison.',
  },
};

export default meta;
